<template>
  <div class="accordion-wrap">
    <div class="accordion-title">
      <div
        class="accordion-icon"
        v-if="iconShow && !iconSlot"
        :style="{
          background:
            (parseInt(iconColorType) + 1) % 3 === 1
              ? '#F87078'
              : (parseInt(iconColorType) + 1) % 3 === 2
              ? '#1FC5E8'
              : (parseInt(iconColorType) + 1) % 3 === 0
              ? '#11C1AE'
              : '#FFB403'
        }"
      ></div>
      <div v-if="iconSlot">
        <slot name="icon"></slot>
      </div>

      <div class="accordion-txt">{{ title }}</div>
      <div class="accordion-icon-right" @click="openSlot">
        <a-icon
          type="up"
          :style="{ fontSize: '10px', color: '#444' }"
          v-if="open"
        />
        <a-icon
          type="down"
          :style="{ fontSize: '10px', color: '#444' }"
          v-if="!open"
        />
      </div>
    </div>
    <div
      class="accordion-box"
      :style="{
        'padding-left': iconShow ? '30px' : '10px',
        'padding-right': '10px',
        'border-bottom': '1px solid #f2f2f2'
      }"
      v-if="open"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Accordion',
  props: {
    title: {
      type: String,
      default: '基础信息'
    },
    iconShow: {
      type: Boolean,
      default: true
    },
    iconColorType: {
      type: [String, Number],
      default: 0
    },
    iconSlot: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: true
    }
  },
  methods: {
    openSlot() {
      this.open = !this.open
    }
  }
}
</script>
<style lang="scss" scoped>
.accordion-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 0 10px;
  border-bottom: 1px solid #f2f2f2;
  .accordion-icon {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 10px;
  }
  .accordion-txt {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    flex: 1;
    font-size: 15px;
    color: #333;
  }
  .accordion-icon-right {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid #e4e4e4;
  }
}
</style>
